import type { ReactNode } from 'react';
import type { Library } from '../api.ts';
import { TvIcon } from '../Icon.tsx';

export function ShowsScreen({
  libraries,
  onOpenLibrary,
  onBack,
  onAddLibrary,
}: {
  libraries: Library[] | null;
  onOpenLibrary: (libraryId: string) => void;
  onBack: () => void;
  onAddLibrary?: (() => void) | undefined;
}): ReactNode {
  const showLib = libraries?.find(
    (l) => l.kind === 'show' || l.name.toLowerCase().includes('dizi'),
  );

  return (
    <div className="music-screen">
      <div className="music-screen__hero">
        <div className="music-screen__icon-wrap" aria-hidden="true">
          <span className="music-screen__icon">
            <TvIcon size={38} />
          </span>
        </div>
        <h1 className="music-screen__title">Dizi Koleksiyonu</h1>
        <p className="music-screen__subtitle">
          Favori televizyon dizilerinizi, sezonları ve bölümleriyle otomatik olarak organize edilmiş
          şekilde takip edin ve izleyin.
        </p>

        {showLib ? (
          <div className="music-screen__action">
            <button
              type="button"
              className="button button--primary"
              onClick={() => onOpenLibrary(showLib.id)}
            >
              Dizi Kütüphanesini Aç ({showLib.name})
            </button>
          </div>
        ) : (
          <div className="music-screen__empty-card">
            <h3>Henüz Dizi Kütüphanesi Eklenmedi</h3>
            <p>
              Dizilerinizin sezon ve bölüm olarak ayrıştırılması için sunucunuzda Dizi türünde bir
              kütüphane oluşturabilirsiniz (ör. <code>/srv/media/diziler</code>).
            </p>
            <div className="music-screen__formats">
              <span className="badge">Otomatik Sezon Eşleme</span>
              <span className="badge">Bölüm Takibi</span>
              <span className="badge">Sonraki Bölüm Akışı</span>
            </div>
            <div className="music-screen__buttons">
              {onAddLibrary && (
                <button type="button" className="button button--primary" onClick={onAddLibrary}>
                  + Dizi Kütüphanesi Ekle
                </button>
              )}
              <button type="button" className="button button--ghost" onClick={onBack}>
                Ana Sayfaya Dön
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
